import React, { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import TahkimSurukleBirakTahta from "../../../components/tahkim/TahkimSurukleBirakTahta";
import { tahkimMerkez } from "../../../lib/tahkimApi";

export default function TahkimBasvuruAsamasiPanel({ q = "" }) {
    const [kanban, setKanban] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const params = {};
            if (q.trim()) params.q = q.trim();
            setKanban(await tahkimMerkez.kanban(params));
        } catch {
            setKanban(null);
            toast.error("Tahta yüklenemedi");
        } finally {
            setLoading(false);
        }
    }, [q]);

    useEffect(() => {
        load();
    }, [load]);

    if (loading && !kanban) {
        return (
            <div className="flex justify-center py-20">
                <Loader2 className="h-9 w-9 animate-spin text-cyan-400" />
            </div>
        );
    }

    const columns = kanban?.columns || [];

    return (
        <TahkimSurukleBirakTahta
            columns={columns}
            loading={loading}
            onRefresh={load}
            baslik="Başvuru aşaması — sürükle-bırak & veri girişi"
            aciklama="STK başvurusu sonrası tüm adımlar burada. Kartı hedef aşama kutusuna sürükleyin; açılan pencerede Tahkim Veri Girişi alanlarını (başvuru, hakem, bilirkişi, karar, ödeme) isteğe bağlı doldurun."
            veriGirisiLink="/e/tahkim-dosyalari"
        />
    );
}
